import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class SweetAlertService {
  constructor() {}

  showMessage(message: string, icon: 'success' | 'error' | 'warning' | 'info') {
    Swal.fire({
      text: message,
      icon: icon,
      toast: false,
      position: 'center',
      showConfirmButton: true,
    });
  }

  showToastMessage(message: string, icon: 'success' | 'error' | 'warning' | 'info') {
    Swal.fire({
      text: message,
      icon: icon,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
  }

  showHtmlMessage(title: string, htmlMessage: string, icon: 'success' | 'error' | 'warning' | 'info') {
    Swal.fire({
      title: title,
      html: htmlMessage,
      icon: icon,
      position: 'center',
      showConfirmButton: true,
    });
  }
}
